import { Component, OnInit, OnDestroy } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { UsState, WebCustomer } from "src/app/models";
import { CustomerService, StatesService } from "src/app/services";
import { Subscription } from "rxjs";
import { AddressInfo } from "./address-info";
import { filter } from "rxjs/operators";

@Component({
  selector: "app-address",
  templateUrl: "./address.component.html",
  styleUrls: ["./address.component.scss"]
})
export class AddressComponent implements OnInit, OnDestroy
{
  public form: FormGroup;
  public states: UsState[] = [];
  private statesSubscription: Subscription;

  private customer: WebCustomer;
  private customerSubscripton: Subscription;

  constructor(
    private fb: FormBuilder,
    private customerService: CustomerService,
    private statesService: StatesService
  ) { }

  ngOnInit(): void
  {
    this.customerSubscripton = this.customerService.customer
      .pipe(filter(customer => !!customer))
      .subscribe(customer =>
      {
        this.customer = customer
      });

    this.statesSubscription = this.statesService.states.subscribe(s => this.states = s);

    this.form = this.fb.group({
      Address1: ["", [Validators.required]],
      Address2: [""],
      City: ["", [Validators.required]],
      State: ["", [Validators.required]],
      Zip: ["", [Validators.required]],
    });

  }

  ngOnDestroy(): void
  {
    this.customerSubscripton.unsubscribe();
    this.statesSubscription.unsubscribe();
  }

  useBillingAddress(value: boolean): void
  {
    if (value)
    {
      this.form.setValue({
        Address1: this.customer.Addr1,
        Address2: this.customer.Addr2,
        City: this.customer.City,
        State: this.customer.State,
        Zip: this.customer.Zip
      });
    }
    else
    {
      this.form.reset();
    }
  }

  public getAddressInfo(): AddressInfo
  {
    const address: AddressInfo = {
      Address1: this.form.get("Address1").value,
      Address2: this.form.get("Address2").value,
      City: this.form.get("City").value,
      State: this.form.get("State").value,
      Zip: this.form.get("Zip").value
    };

    return address;
  }

}
